import { useTranslation } from 'react-i18next';
import { BaseDialog } from '@/common/components/base-dialog/BaseDialog';

interface PushWarningDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onPull: () => void;
  onPush: () => void;
}

export const PushWarningDialog = ({
  open,
  onOpenChange,
  onPull,
  onPush,
}: PushWarningDialogProps) => {
  const { t } = useTranslation();

  return (
    <BaseDialog
      open={open}
      onOpenChange={onOpenChange}
      size="sm"
      intent="warning"
      title={t(($) => $.common.settings['work-integrations'].pushWarningDialog.title)}
      description={t(($) => $.common.settings['work-integrations'].pushWarningDialog.description)}
      primaryAction={{
        label: t(($) => $.common.settings['work-integrations'].pushWarningDialog.pullNow),
        onClick: () => {
          onOpenChange(false);
          onPull();
        },
        'data-testid': 'pull-now-button',
      }}
      secondaryAction={{
        label: t(($) => $.common.settings['work-integrations'].pushWarningDialog.publishAnyway),
        onClick: () => {
          onOpenChange(false);
          onPush();
        },
        'data-testid': 'publish-anyway-button',
      }}
      additionalAction={{
        label: t(($) => $.common.cancel),
        onClick: () => onOpenChange(false),
        'data-testid': 'push-warning-cancel-button',
      }}
    />
  );
};
